import { type Episode, type Movie, type Person, type Season, type Tv } from '@tmdb-graphql-api/schema/types';
import { type DetailsResponse } from '../types.ts';

export const isMovieData = (data: DetailsResponse): data is { movie: Movie } => 'movie' in data;

export const isPersonData = (data: DetailsResponse): data is { person: Person } => 'person' in data;

export const isEpisodeData = (data: DetailsResponse): data is { episode: Episode; season: Season; tv: Tv } =>
  'episode' in data;

export const isSeasonData = (data: DetailsResponse): data is { season: Season; tv: Tv } => 'season' in data;

export const isTvData = (data: DetailsResponse): data is { tv: Tv } => 'tv' in data;
